import { render, staticRenderFns } from "./TheTeam.vue?vue&type=template&id=dbf8810e&scoped=true&"
import script from "./TheTeam.vue?vue&type=script&lang=js&"
export * from "./TheTeam.vue?vue&type=script&lang=js&"
import style0 from "./TheTeam.vue?vue&type=style&index=0&id=dbf8810e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf8810e",
  null
  
)

export default component.exports